import { render, staticRenderFns } from "./system_management_logs.vue?vue&type=template&id=84daa5b2&scoped=true&"
import script from "./system_management_logs.vue?vue&type=script&lang=js&"
export * from "./system_management_logs.vue?vue&type=script&lang=js&"
import style0 from "./system_management_logs.vue?vue&type=style&index=0&id=84daa5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84daa5b2",
  null
  
)

export default component.exports